import React, { useEffect } from "react";
import { useAppDispatch } from "../../store/hooks/store.hooks";
// import "./Payments.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import { Loader } from "../../components/loader/loader";
import Main from "../Main/main";
import { setRegistrationModal } from "../../store/models/auth/auth.slice";
import { PartnerService } from "../../services/partner/partner.service";
import { Footer } from "../../components/Footer/Footer";

interface IRegistration {}

const Registration: React.FC<IRegistration> = ({}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const value = window.location.search.substr(1);
    const partnerService = new PartnerService();

    localStorage.setItem("regkey", value);

    dispatch(setRegistrationModal(true));
  }, [dispatch]);

  return (
    <React.Fragment>
      <Main />
      <Footer />
    </React.Fragment>
  );
};

export default Registration;
